<template>
	<section>
		<el-tabs v-model="tabsName" type="card" @tab-click="handleTabClick">
			<!-- 用户列表 -->
			<el-tab-pane  :name="TabName.USERLIST">
                <span slot="label">
                    <i class="el-icon-s-home"></i>
                    {{ $t("serviceMaintenance.userList") }}
                </span>
				<ServiceUserList
					:tableData="expandedTableData"
					:loading="loading"
					:spanArr="spanArr"
                    :handleBatchSuccess="handleBatchSuccess"

				/>
			</el-tab-pane>

			<!-- 服务商列表 -->
			<el-tab-pane :name="TabName.SERVICEPROVIDERLIST">
                <span slot="label">
                    <i class="el-icon-message"></i>
                    {{ $t("serviceMaintenance.serviceProviderList") }}
                    <span v-if="unreadStatus.has_read === 0" class="badge unread-badge"></span>
                </span>
				<ServiceProviderList
                    :serviceProviderData="serviceProviderData"
                    :loading="serviceProviderLoading"
                />
			</el-tab-pane>
		</el-tabs>


	</section>
</template>

<script>
import ServiceUserList from "./service-user-list.vue";
import ServiceProviderList from "./service-provider-list.vue";

import {
    getUserPhoneList,
    getServiceProviderMaintenanceList,
    getServiceProviderReadStatus,
    postServiceProviderReadStatus
} from "../../services/api-v2/api-v2";

const TabName = {
	USERLIST: "userlist",
	SERVICEPROVIDERLIST: "serviceproviderlist",
};

export default {
	name: "ServiceMaintenance",

	components: {
		ServiceUserList,
		ServiceProviderList,
	},

	data() {
		return {
			TabName,
			tabsName: TabName.USERLIST,

			loading: false,

			usersListData: [],
			expandedTableData: [],
			spanArr: [],

			serviceProviderData: [],
			serviceProviderLoading: false,

            // 添加服务商列表阅读状态
            unreadStatus: {
                has_read: 1, // 默认已读
                latest_read_at: null,
                first_merchant_listing_time: null
            }

		};
	},

	created() {
		this.initUsersListData();
        this.loadUnreadStatus(); // 加载阅读状态
	},



	methods: {
		// tab切换
		handleTabClick(tab) {
			switch (tab.name) {
				case TabName.USERLIST:
					this.initUsersListData();
					break;
				case TabName.SERVICEPROVIDERLIST:
					this.initServiceProviderList();

                    // 如果未读，点击后标记为已读
                    if (this.unreadStatus.has_read === 0) {
                        this.markAsRead();

                        // 更新导航栏的红点状态
                        this.$emit('updateServiceProviderUnreadStatus', 1);
                    }
					break;
			}
		},

		// 加载服务商列表阅读状态
		async loadUnreadStatus() {
			try {
				const response = await getServiceProviderReadStatus();
				if (response && response.data) {
					this.unreadStatus = response.data;
				}
			} catch (error) {
				console.error("Failed to load unread status:", error);
			}
		},

        // 标记为已读
        async markAsRead() {
            try {
                await postServiceProviderReadStatus();
                // 更新本地状态
                this.unreadStatus.has_read = 1;
                this.unreadStatus.latest_read_at = new Date().toISOString();
            } catch (error) {
                console.error("Failed to mark as read:", error);
            }
        },

		// 初始化用户数据
		async initUsersListData() {
			this.loading = true;
			try {
				const { data } = await getUserPhoneList(this.customerId);


				this.usersListData = data;

				// 先展开，再计算合并行
			    this.expandNewDataStructure();

				this.getSpanArr();
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 初始化服务商列表数据
		async initServiceProviderList() {
			this.serviceProviderLoading = true;
			try {
				const { data } = await getServiceProviderMaintenanceList();
				this.serviceProviderData = data;
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.serviceProviderLoading = false;
			}
		},

		// 展平新数据结构
		expandNewDataStructure() {
			this.expandedTableData = [];

			this.usersListData.forEach((phoneGroup) => {
				phoneGroup.customers.forEach((customer) => {
					this.expandedTableData.push({
						// 根据新数据结构映射字段，只保留实际存在的字段
						name: phoneGroup.name,
						phone_number: phoneGroup.phone_number,
						customer_id: customer.customer_id,
						restaurant_name: customer.name,
						phone_number_languages: customer.phone_number_languages,
						original_phone_group: phoneGroup,
					});
				});
			});
		},


		// 合并行计算（保持原逻辑）
		getSpanArr() {
			this.spanArr = [];
			let pos = 0;

			for (let i = 0; i < this.expandedTableData.length; i++) {
				if (i === 0) {
					this.spanArr.push(1);
					pos = 0;
				} else {
					if (this.expandedTableData[i].phone_number === this.expandedTableData[i - 1].phone_number) {
						this.spanArr[pos] += 1;
						this.spanArr.push(0);
					} else {
						this.spanArr.push(1);
						pos = i;
					}
				}
			}
		},


		// 批量成功回调
		handleBatchSuccess() {
			this.initUsersListData();
		},
	},
};
</script>

<style lang="less" scoped>

.badge {
	display: inline-block;
	width: 8px;
	height: 8px;
	background: #f56c6c;
	border-radius: 50%;
	margin-left: 4px;
}

// 新增未读状态的红点样式
.unread-badge {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.7);
    }
    70% {
        box-shadow: 0 0 0 6px rgba(245, 108, 108, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
    }
}

</style>